import { UserAddress } from "./Address";
import { BOOLEAN_AS_STRING } from "./Common";

/* eslint-disable @typescript-eslint/naming-convention */
export enum DELIVERY_SPEED {
    BATCH_NO_RUSH = "BATCH_NO_RUSH",
    PRIORITY = "PRIORITY",
    STANDARD = "STANDARD",
    BATCH_OPT_IN = "BATCH_OPT_IN",
    EXPRESS = "EXPRESS",
    PREORDER = "PREORDER",
}

export const DELIVERY_SPEED_DISPLAY = {
    BATCH_NO_RUSH: "Smart Saver",
    PRIORITY: "Priority",
    STANDARD: "Standard",
    BATCH_OPT_IN: "Batch Opt in",
    EXPRESS: "Express",
    PREORDER: "Preorder",
};

export enum DELIVERY_SPEED_STRATEGY {
    GREYED = "GREYED",
    NOT_VISIBLE = "NOT_VISIBLE",
    VISIBLE = "VISIBLE",
}

export interface DeliverySpeedNudge {
    icon?: string;
    message?: string;
}

export interface O2R {
    min: number;
    max: number;
    point: number;
}

export interface OptionMeta {
    showShimmer?: boolean;
    tooltipData?: {
        title?: string;
        description?: string;
    };
    highlightColor?: string;
    headingInfoColor?: string;
}

export interface DeliverySpeedDetail {
    type: DELIVERY_SPEED;
    sla: number;
    sla_range_min: number;
    sla_range_max: number;
    sla_message?: string;
    strategy: DELIVERY_SPEED_STRATEGY | null;
    o2r?: O2R | null;
    unavailabilityReason?: string;
}

export interface IBanner {
    text?: string;
    color?: string;
    bgColor?: string;
    iconId?: string;
    ctaEnabled?: boolean;
}

export interface TransformedDeliverySpeedOptionOfferInfo extends DeliverySpeedOptionOfferInfo {
    timeLeftInSeconds?: number;
    offerMessage?: string;
}
export interface Option {
    heading: string;
    subHeading?: string;
    headingInfo?: string;
    option: string;
    isDisabled?: boolean;
    meta?: OptionMeta;
    slaData?: DeliverySpeedDetail;
    bannerData?: IBanner;
    offerInfo?: TransformedDeliverySpeedOptionOfferInfo;
    deliverySpeedOnlyPresentation?: string;
    deliverySpeedOnlyPresentationIcon?: string;
    deliverySpeedWithIcon?: string;
}

export enum NoRushSavingsType {
    EcoSaver = "ECO_SAVER",
    Monetary = "MONETARY",
}

interface HighlightBulletPointsMeta {
    title?: string;
    description?: string;
    shimmer?: BOOLEAN_AS_STRING;
    // This is to only highlight bullet point in different color
    highlight_color?: string;
}

export interface DeliverySpeedOptionOfferInfo {
    offer_timer_expiry?: string;
    offer_timer_start?: string;
    color?: string;
    offer_message?: string;
    offer_pre_timer_message?: string;
    gradient?: string;
}

export enum DISCOUNT_TYPE {
    FREE_DELIVERY = "BATCHABLE_FREEDEL",
    CASHBACK = "BATCHABLE_CASHBACK",
}

export interface popupInfoSuccess {
    icon: string;
    message: string;
    ctaText: string;
    lottie_id: string;
    discountType: DISCOUNT_TYPE;
}

export interface DeliverySpeedOption {
    delivery_speed: DELIVERY_SPEED;
    heading_text: string;
    highlight_bullet_points: string[];
    bullet_points: string[];
    bottom_banner: string;
    highlight_colour?: string;
    delivery_speed_with_icon?: string;
    delivery_speed_only_presentation_icon?: string;
    delivery_speed_only_presentation?: string;
    bottom_meta?: {
        lottie_id: string;
        banner_color: string;
        icon_id?: string;
        banner_bg_color?: string;
        cta_info?: { cta_enabled: string };
    };
    offer_info?: DeliverySpeedOptionOfferInfo;
    lottie_id?: string;
    savings_type?: NoRushSavingsType;
    metadata?: {
        show_bg_gradient?: boolean;
    };
    highlight_bullet_points_meta?: HighlightBulletPointsMeta[];
    popup_info?: popupInfoSuccess;
    discount_type?: DISCOUNT_TYPE;
}

export interface DeliverySpeedWidgetInfo {
    delivery_speed_options: DeliverySpeedOption[];
    standard_only_available_text?: string;
    delivery_speed_widget_subtext?: string;
    optin_text?: string;
    single_mode_servicable_sla_text?: string;
}

export interface DeliverySpeedPresentationInfo {
    delivery_speed_widget_info?: DeliverySpeedWidgetInfo;
    delivery_speed_metadata?: {
        address_text_prefix: string;
        address_text_lottie_id: string;
    };
}

export interface DeliverySpeedPriceInfo {
    priority_fee_message?: string;
    no_rush_discount_message?: string;
}

export interface DeliverySpeedCrouton {
    icon?: string;
    message: string;
    subtext?: string;
}

export interface ServiceabilityParams {
    userLoggedIn: boolean;
    selectedAddress: UserAddress | null;
}

export interface EcoSaverLottieSuccess {
    showExpressLottie: boolean;
    setShowExpressLottie: (visibility: boolean) => void;
    lottieId?: string;
    onImpressionEcoSaverLottie: (cartId?: number, addressId?: string, lottieId?: string) => void;
    cartId?: number;
    addressId?: string;
    discountType: DISCOUNT_TYPE;
}
